import React from "react";
import { FavoritePairShortcut } from "./FavoritePairShortcut";
import { useFavoritePairs } from "./useFavoritePairs";
import { useHorizontalWheelScroll } from "./useHorizontalWheelScroll";

/**
 * Quick switch buttons for favorite pairs, newest first.
 * The track fits 4 pairs; the rest are reachable by horizontal scroll.
 *
 * @param {object} props
 * @param {(pair: object) => void} props.onSelect
 */
export const FavoritePairsShortcuts = ({ onSelect }) => {
  const { favorites, removeFavorite } = useFavoritePairs();
  const trackRef = useHorizontalWheelScroll();

  if (!favorites.length) return null;

  return (
    <>
      <div className="futures-quote__divider" />
      <div className="futures-quote__recents">
        <div ref={trackRef} className="futures-quote__recents-track">
          {favorites.map((pair) => (
            <FavoritePairShortcut
              key={pair.slug}
              pair={pair}
              onSelect={onSelect}
              onRemove={removeFavorite}
            />
          ))}
        </div>
      </div>
    </>
  );
};
